import ReactDOM from 'react-dom';
import React from 'react';
import App from './App';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './index.scss';

ReactDOM.render(
  <React.Fragment>
    <App />
  </React.Fragment>,
  document.getElementById('root')
);
